﻿let selectedDeposit, selectedTerm, selectedMileage;
let updatingDropdowns = false;
let animationsComplete = 0;
let dropdownsInitialised = false;
let lastUpdatedDropdown = "";
let lastValidPrice = null;
let lastValidInitialRental = null;

document.addEventListener('DOMContentLoaded', () =>
{
    SetupCustomiseYourLease();
});

function SetupCustomiseYourLease()
{
    document.querySelectorAll('[data-dropdown]').forEach(dropdown =>
    {
        dropdown.addEventListener('click', handleDropdownClick);
    });

    document.addEventListener('click', handleOutsideClick);
}

function handleDropdownClick(event)
{
    const dropdown = event.currentTarget;
    const isDropdownTarget = event.target.hasAttribute('data-dropdown') || event.target.closest('[data-dropdown] [data-value]');

    // Close other dropdowns before toggling the current one
    document.querySelectorAll('[data-dropdown] [data-options].show').forEach(openDropdown =>
    {
        if (!dropdown.contains(openDropdown))
        {
            openDropdown.classList.remove('show');
        }
    });

    if (isDropdownTarget)
    {
        toggleDropdown(dropdown);
    }

    event.stopPropagation();
}

function handleOutsideClick(event)
{
    document.querySelectorAll('[data-dropdown] [data-options].show').forEach(openDropdown =>
    {
        if (!openDropdown.closest('[data-dropdown]').contains(event.target))
        {
            openDropdown.classList.remove('show');
        }
    });
}

function toggleDropdown(dropdown)
{
    const optionsDiv = dropdown.querySelector('[data-options]');
    optionsDiv.classList.toggle('show');
}

function PopulateCustomiseYourLease()
{
    if (!document.querySelector("#customise-modal").classList.contains("show"))
    {
        dropdownsInitialised = false;
    }

    if (!dropdownsInitialised)
    {
        initialiseDropdowns();
    }

    populateDropdowns();
}

function initialiseDropdowns()
{
    selectedDeposit = { value: dealDeposit };
    selectedTerm = { value: dealTerm };
    selectedMileage = { value: dealMileage };

    const formattedPrice = parseFloat(basePrice).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    const spanPrice = document.querySelector("[data-price]");
    spanPrice.textContent = "£" + formattedPrice;

    dropdownsInitialised = true;
}

function populateDropdowns()
{
    const rootDiv = document.querySelector("#profile-options");
    rootDiv.querySelector("[data-dropdown='deposit']").innerHTML = PopulateCustomiseLeaseDropdown("Deposit", uniqueProfileValues.Deposits, selectedDeposit.value);
    rootDiv.querySelector("[data-dropdown='term']").innerHTML = PopulateCustomiseLeaseDropdown("Term", uniqueProfileValues.Terms, selectedTerm.value);
    rootDiv.querySelector("[data-dropdown='mileage']").innerHTML = PopulateCustomiseLeaseDropdown("Mileage", uniqueProfileValues.Mileages, selectedMileage.value);
}

function PopulateCustomiseLeaseDropdown(dropdownType, dropdownValues, selectedValue)
{
    const shownPrice = parseFloat(document.querySelector('[data-price]').textContent.replace('£', '').replace(/,/g, ''));
    let optionsHtml = dropdownValues.map(value =>
    {
        const priceDifference = calculatePriceDifference(dropdownType, value);
        const formattedDifference = getFormattedDifference(priceDifference, value, selectedValue);

        if (dropdownType == "Mileage" && selectedValue == "0") {
            value = "Unlimited";
            selectedValue = "Unlimited";
        }

        return `
            <div class="option" data-option onclick="selectOption('${dropdownType}', '${value}', ${priceDifference !== null ? priceDifference : 'null'})">
                <span>${value == 0 ? 'Unlimited' : value}</span>
                <span class="price-difference" data-difference>${formattedDifference}</span>
            </div>`;
    }).join("");

    return `
        <span data-value>${selectedValue}</span>
        <span class="price-difference" data-difference></span>
        <div class="options" data-options>${optionsHtml}</div>`;
}

function getFormattedDifference(priceDifference, value, selectedValue)
{
    if (value === selectedValue)
    {
        return "(Selected)";
    }
    else if (priceDifference === null)
    {
        return "(Combination unavailable)";
    }
    else if (priceDifference === 0)
    {
        return "£0.00";
    }
    else
    {
        return priceDifference > 0
            ? `+ £${priceDifference.toFixed(2)} p/m`
            : `- £${Math.abs(priceDifference).toFixed(2)} p/m`;
    }
}

function selectOption(dropdownType, selectedValue, priceDifference)
{
    lastUpdatedDropdown = dropdownType;

    const selectedDiv = document.querySelector(`[data-dropdown="${dropdownType.toLowerCase()}"]`);
    const selectedValueDiv = selectedDiv.querySelector('[data-value]');
    const priceDifferenceDiv = selectedDiv.querySelector('[data-difference]');
    const optionsDiv = selectedDiv.querySelector('[data-options]');

    if (optionsDiv)
    {
        optionsDiv.classList.remove('show');
    }

    selectedValueDiv.textContent = selectedValue;
    priceDifferenceDiv.textContent = getFormattedDifference(priceDifference, selectedValue, selectedValue);

    UpdateCustomiseLease({ dropdownType, selectedValue });
}

function calculatePriceDifference(dropdownType, selectedValue)
{
    const shownPrice = parseFloat(document.querySelector('[data-price]').textContent.replace('£', '').replace(/,/g, ''));
    const localValues = {
        Deposit: selectedDeposit.value,
        Term: selectedTerm.value,
        Mileage: selectedMileage.value
    };

    if (dropdownType === "Deposit")
    {
        localValues.Deposit = selectedValue;
    }

    if (dropdownType === "Term")
    {
        localValues.Term = selectedValue;
    }

    if (dropdownType === "Mileage")
    {
        localValues.Mileage = selectedValue;
    }

    const matchingDeal = relatedDeals.find(deal =>
        deal.Deposit === localValues.Deposit &&
        deal.Term === localValues.Term &&
        deal.Mileage === localValues.Mileage
    );

    return matchingDeal ? matchingDeal.Price - shownPrice : null;
}

function animatePriceChange(oldValue, newValue, duration, elementSelector, prefix = "£", suffix = "", callback)
{
    const element = document.querySelector(elementSelector);
    if (!element) return;

    const totalSteps = 30;
    const stepDuration = duration / totalSteps;
    const valueDifference = newValue - oldValue;
    const valueIncrement = valueDifference / totalSteps;

    let currentStep = 0;

    const interval = setInterval(() =>
    {
        currentStep++;

        const currentValue = oldValue + valueIncrement * currentStep;
        element.textContent = `${prefix}${currentValue.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}${suffix}`;

        if (currentStep >= totalSteps)
        {
            clearInterval(interval);
            element.textContent = `${prefix}${newValue.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}${suffix}`;
            if (callback)
            {
                callback();
            }
        }
    }, stepDuration);
}

function UpdateCustomiseLease({ dropdownType, selectedValue })
{
    // Initialize prices and rentals, ensuring they are numbers
    let oldPrice = parseFloat(document.querySelector('[data-price]').textContent.replace('£', '').replace(/,/g, '')) || 0;
    let oldInitialRental = parseFloat(document.querySelector('[data-initial]').textContent.split('= £')[1].replace(/,/g, '')) || 0;
    animationsComplete = 0;

    // Update selected values based on dropdown selection
    if (dropdownType === "Deposit")
    {
        selectedDeposit.value = selectedValue;
    }
    if (dropdownType === "Term")
    {
        selectedTerm.value = selectedValue;
    }
    if (dropdownType === "Mileage")
    {
        selectedMileage.value = selectedValue;
    }

    // Find matching deal
    const matchingDeal = relatedDeals.find(deal =>
        deal.Deposit === selectedDeposit.value &&
        deal.Term === selectedTerm.value &&
        deal.Mileage === selectedMileage.value
    );

    // Set new prices and initial rental based on deal match
    let newPrice = matchingDeal ? matchingDeal.Price : oldPrice; // fallback to old price if no match
    let newInitialRental = matchingDeal
        ? newPrice * parseInt(selectedDeposit.value.split(" ")[0])
        : oldInitialRental; // fallback to old initial rental if no match

    if (matchingDeal)
    {
        lastValidPrice = newPrice;
        lastValidInitialRental = newInitialRental;
    }

    // Ensure `lastValidPrice` and `lastValidInitialRental` are never null
    if (lastValidPrice === null)
    {
        lastValidPrice = 0;
    }
    if (lastValidInitialRental === null)
    {
        lastValidInitialRental = 0;
    }

    // Check and apply invalid classes before animations
    const priceWrapper = document.querySelector('.price-wrapper');
    const spanInitial = document.querySelector('[data-initial]');
    const refreshDealBtn = document.querySelector('[data-refresh-deal]');

    if (!matchingDeal)
    {
        priceWrapper.classList.add('invalid');
        spanInitial.classList.add('invalid');
        refreshDealBtn.classList.add('disabled', 'error');
        refreshDealBtn.style.cursor = 'no-drop';
        refreshDealBtn.textContent = 'Unavailable';
        refreshDealBtn.removeEventListener('click', GoToCustomiseLeaseSelection);
    }
    else
    {
        priceWrapper.classList.remove('invalid');
        spanInitial.classList.remove('invalid');
        refreshDealBtn.classList.remove('disabled', 'error');
        refreshDealBtn.style.cursor = 'pointer';
        refreshDealBtn.textContent = 'Save changes';
        refreshDealBtn.addEventListener('click', GoToCustomiseLeaseSelection);
    }

    // Start animations after setting validity
    animatePriceChange(oldPrice, newPrice, 500, '[data-price]', "£", "", function ()
    {
        animationsComplete++;
        checkAnimationComplete();
    });

    animatePriceChange(oldInitialRental, newInitialRental, 500, '[data-initial]', `${selectedDeposit.value} upfront = £`, "", function ()
    {
        animationsComplete++;
        checkAnimationComplete();
    });
}

function checkAnimationComplete()
{
    if (animationsComplete === 2 && !updatingDropdowns)
    {
        updatingDropdowns = true;
        PopulateCustomiseYourLease(document.querySelector("#profile-options"));
        updatingDropdowns = false;

        let isMatch = relatedDeals.some(deal =>
            deal.Deposit === selectedDeposit.value &&
            deal.Term === selectedTerm.value &&
            deal.Mileage === selectedMileage.value
        );

        const priceWrapper = document.querySelector('.price-wrapper');
        const spanInitial = document.querySelector('[data-initial]');
        const refreshDealBtn = document.querySelector('[data-refresh-deal]');

        if (!isMatch)
        {
            priceWrapper.classList.add('invalid');
            spanInitial.classList.add('invalid');
            spanInitial.textContent = `${selectedDeposit.value} upfront = £${lastValidInitialRental.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
            refreshDealBtn.classList.add('disabled', 'error');
            refreshDealBtn.style.cursor = 'no-drop';
            refreshDealBtn.textContent = 'Unavailable';
            refreshDealBtn.removeEventListener('click', GoToCustomiseLeaseSelection);
        }
        else
        {
            priceWrapper.classList.remove('invalid');
            spanInitial.classList.remove('invalid');
            refreshDealBtn.classList.remove('disabled', 'error');
            refreshDealBtn.style.cursor = 'pointer';
            refreshDealBtn.textContent = 'Save changes';
            refreshDealBtn.addEventListener('click', GoToCustomiseLeaseSelection);
        }
    }
}

function GoToCustomiseLeaseSelection()
{
    const selectedDeal = relatedDeals.find(deal =>
        selectedDeposit.value === deal.Deposit && selectedTerm.value === deal.Term && selectedMileage.value === deal.Mileage
    );

    if (selectedDeal)
    {
        // Check if d17 in the GADataModel is "WeeklySpecialOffers"
        const gaData = document.getElementById('GADataModel');
        const gaDataJson = gaData ? JSON.parse(gaData.textContent) : null;

        if (gaDataJson && gaDataJson.d17 === "WeeklySpecialOffers")
        {
            const url = new URL(selectedDeal.Url);
            url.searchParams.set('wso', 'true');
            selectedDeal.Url = url.toString();
        }

        window.location = selectedDeal.Url;
    }
}

